// src/services/authService.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API, axiosInstance } from "lib";

export const adminLogin = createAsyncThunk(
  "Admin login",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API.ADMIN_LOGIN, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const verifyLogin = createAsyncThunk(
  "Verify login",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API.VERIFY_LOGIN, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const logout = createAsyncThunk(
  "Admin logout",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API.ADMIN_LOGOUT, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
